export class NavConstants {
    static VIEW_MAP_LINK_TEXT = "View map";
    static LOGO_SOURCE = "assets/images/afla_home_icon.png";
    static MANAGE_ORGANISATION_LINK_TEXT = "Organisations";
    static ADD_MODULE_LINK_TEXT = "Add module";
    static MANAGE_MOBILE_CONFIG_LINK_TEXT = "Mobile configuration";
    static MAINTENANCE_MODE_CONFIG_TEXT = "Maintenance mode settings";
    static USER_NAME_AND_ROLE_TEXT = "Role:";
    static USER_NAME_TEXT = "User:";
    static LOGOUT_LINK_TEXT = "Logout";
    static SETTINGS_LINK_TEXT = "Settings";
    static APPLY_TO_ORGANISATION_LINK_TEXT = "Apply to organisation";
    static AFLA_SETTINGS_TEXT = "AFLA settings";
    static APP_TITLE = "ArcGIS For Local Authorities (AFLA)";
    static HOME_LINK_TEXT = "Home";
    static APPLICATIONS_HEADING_TEXT = "Applications";
    static PROPERTIES_HEADING_TEXT = "Properties";
    static ARCGIS_ITEMS_HEADING_TEXT = "ArcGIS items";
    static VALUATION_RUN_MANAGEMENT_HEADING_TEXT = "Valuation run management";
    static ATTRIBUTES_AND_PARAMETERS_HEADING_TEXT = "Attributes and parameters";
    static BAYS_HEADING_TEXT = "Bays";
    static POI_HEADING_TEXT = "POI";
    static STREETS_HEADING_TEXT = "Streets";
    static GRAVES_HEADING_TEXT = "Graves";
    static LOCATION_HEADING_TEXT = "Cemeteries / Graves";
    static MAP_TOOLS_LINK_TEXT = "Tools";
    static ORGANISATION_SUSPENDED_TEXT = "Organisation has been suspended. Please contact your system administartor.";
    static MODULE_SUSPENDED_TEXT = "Module has been suspended. Please contact your system administartor.";
    static FEATURE_SEARCH_HEADING_TEXT = "Search";
    static APPLICATION_SEARCH_HEADING_TEXT = "Application search";
}
